export const allWarehouseLocations = {
    ASMAT: [
        ['D-04-10-3', '', '', 'D-04-09-1', 'D-03-10-3', '', '', 'D-03-09-1', 'D-02-10-3', '', '', 'D-02-09-1', 'D-01-11-3', '', '', 'D-01-10-1'],
        ['D-04-10-2', '', '', 'D-04-09-2', 'D-03-10-2', '', '', 'D-03-09-2', 'D-02-10-2', '', '', 'D-02-09-2', 'D-01-11-2', '', '', 'D-01-10-2'],
        ['D-04-10-1', '', '', 'D-04-09-3', 'D-03-10-1', '', '', 'D-03-09-3', 'D-02-10-1', '', '', 'D-02-09-3', 'D-01-11-1', '', '', 'D-01-10-3'],
        ['D-04-11-3', '', '', 'D-04-08-1', 'D-03-11-3', '', '', 'D-03-08-1', 'D-02-11-3', '', '', 'D-02-08-1', 'D-01-12-3', '', '', 'D-01-09-1'],
        ['D-04-11-2', '', '', 'D-04-08-2', 'D-03-11-2', '', '', 'D-03-08-2', 'D-02-11-2', '', '', 'D-02-08-2', 'D-01-12-2', '', '', 'D-01-09-2'],
        ['D-04-11-1', '', '', 'D-04-08-3', 'D-03-11-1', '', '', 'D-03-08-3', 'D-02-11-1', '', '', 'D-02-08-3', 'D-01-12-1', '', '', 'D-01-09-3'],
        ['D-04-12-3', '', '', 'D-04-07-1', 'D-03-12-3', '', '', 'D-03-07-1', 'D-02-12-3', '', '', 'D-02-07-1', 'D-01-13-3', '', '', 'D-01-08-1'],
        ['D-04-12-2', '', '', 'D-04-07-2', 'D-03-12-2', '', '', 'D-03-07-2', 'D-02-12-2', '', '', 'D-02-07-2', 'D-01-13-2', '', '', 'D-01-08-2'],
        ['D-04-12-1', '', '', 'D-04-07-3', 'D-03-12-1', '', '', 'D-03-07-3', 'D-02-12-1', '', '', 'D-02-07-3', 'D-01-13-1', '', '', 'D-01-08-3'],
        ['D-04-13-3', '', '', 'D-04-06-1', 'D-03-13-3', '', '', 'D-03-06-1', 'D-02-13-3', '', '', 'D-02-06-1', 'D-01-14-3', '', '', 'D-01-07-1'],
        ['D-04-13-2', '', '', 'D-04-06-2', 'D-03-13-2', '', '', 'D-03-06-2', 'D-02-13-2', '', '', 'D-02-06-2', 'D-01-14-2', '', '', 'D-01-07-2'],
        ['D-04-13-1', '', '', 'D-04-06-3', 'D-03-13-1', '', '', 'D-03-06-3', 'D-02-13-1', '', '', 'D-02-06-3', 'D-01-14-1', '', '', 'D-01-07-3'],
        ['D-04-14-3', '', '', 'D-04-05-1', 'D-03-14-3', '', '', 'D-03-05-1', 'D-02-14-3', '', '', 'D-02-05-1', 'D-01-15-3', '', '', 'D-01-06-1'],
        ['D-04-14-2', '', '', 'D-04-05-2', 'D-03-14-2', '', '', 'D-03-05-2', 'D-02-14-2', '', '', 'D-02-05-2', 'D-01-15-2', '', '', 'D-01-06-2'],
        ['D-04-14-1', '', '', 'D-04-05-3', 'D-03-14-1', '', '', 'D-03-05-3', 'D-02-14-1', '', '', 'D-02-05-3', 'D-01-15-1', '', '', 'D-01-06-3'],
        ['D-04-15-3', '', '', 'D-04-04-1', 'D-03-15-3', '', '', 'D-03-04-1', 'D-02-15-3', '', '', 'D-02-04-1', 'D-01-16-3', '', '', 'D-01-05-1'],
        ['D-04-15-2', '', '', 'D-04-04-2', 'D-03-15-2', '', '', 'D-03-04-2', 'D-02-15-2', '', '', 'D-02-04-2', 'D-01-16-2', '', '', 'D-01-05-2'],
        ['D-04-15-1', '', '', 'D-04-04-3', 'D-03-15-1', '', '', 'D-03-04-3', 'D-02-15-1', '', '', 'D-02-04-3', 'D-01-16-1', '', '', 'D-01-05-3'],
        ['D-04-16-3', '', '', 'D-04-03-1', 'D-03-16-3', '', '', 'D-03-03-1', 'D-02-16-3', '', '', 'D-02-03-1', 'D-01-17-3', '', '', 'D-01-04-1'],
        ['D-04-16-2', '', '', 'D-04-03-2', 'D-03-16-2', '', '', 'D-03-03-2', 'D-02-16-2', '', '', 'D-02-03-2', 'D-01-17-2', '', '', 'D-01-04-2'],
        ['D-04-16-1', '', '', 'D-04-03-3', 'D-03-16-1', '', '', 'D-03-03-3', 'D-02-16-1', '', '', 'D-02-03-3', 'D-01-17-1', '', '', 'D-01-04-3'],
        ['D-04-17-3', '', '', 'D-04-02-1', 'D-03-17-3', '', '', 'D-03-02-1', 'D-02-17-3', '', '', 'D-02-02-1', 'D-01-18-3', '', '', 'D-01-03-1'],
        ['D-04-17-2', '', '', 'D-04-02-2', 'D-03-17-2', '', '', 'D-03-02-2', 'D-02-17-2', '', '', 'D-02-02-2', 'D-01-18-2', '', '', 'D-01-03-2'],
        ['D-04-17-1', '', '', 'D-04-02-3', 'D-03-17-1', '', '', 'D-03-02-3', 'D-02-17-1', '', '', 'D-02-02-3', 'D-01-18-1', '', '', 'D-01-03-3'],
        ['D-04-18-3', '', '', 'D-04-01-1', 'D-03-18-3', '', '', 'D-03-01-1', 'D-02-18-2', '', '', 'D-02-01-1', 'D-01-19-2', '', '', 'D-01-02-1'],
        ['D-04-18-2', '', '', 'D-04-01-2', 'D-03-18-2', '', '', 'D-03-01-2', 'D-02-18-1', '', '', 'D-02-01-2', 'D-01-19-1', '', '', 'D-01-02-2'],
        ['D-04-18-1', '', '', 'D-04-01-3', 'D-03-18-1', '', '', '', '', '', '', '', '', '', '', 'D-01-01-1'],
        ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'D-01-01-2'],
        ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', 'D-01-01-3'],
        ['D-05-01-3', 'D-05-01-2', 'D-05-01-1', 'D-05-02-3', 'D-05-02-2', 'D-05-02-1', 'D-05-03-3', 'D-05-03-2', 'D-05-03-1', 'D-05-04-3', 'D-05-04-2', 'D-05-04-1', 'D-05-05-3', 'D-05-05-2', 'D-05-05-1', '']
    ],
    JAMS: [
        ['J-04-09-3', '', '', 'J-04-08-1', 'J-03-09-3', '', '', 'J-03-08-1', 'J-02-09-3', '', '', 'J-02-08-1', 'J-01-09-3', '', '', 'J-01-08-1'],
        ['J-04-09-2', '', '', 'J-04-08-2', 'J-03-09-2', '', '', 'J-03-08-2', 'J-02-09-2', '', '', 'J-02-08-2', 'J-01-09-2', '', '', 'J-01-08-2'],
        ['J-04-09-1', '', '', 'J-04-08-3', 'J-03-09-1', '', '', 'J-03-08-3', 'J-02-09-1', '', '', 'J-02-08-3', 'J-01-09-1', '', '', 'J-01-08-3'],
        ['J-04-10-3', '', '', 'J-04-07-1', 'J-03-10-3', '', '', 'J-03-07-1', 'J-02-10-3', '', '', 'J-02-07-1', 'J-01-10-3', '', '', 'J-01-07-1'],
        ['J-04-10-2', '', '', 'J-04-07-2', 'J-03-10-2', '', '', 'J-03-07-2', 'J-02-10-2', '', '', 'J-02-07-2', 'J-01-10-2', '', '', 'J-01-07-2'],
        ['J-04-10-1', '', '', 'J-04-07-3', 'J-03-10-1', '', '', 'J-03-07-3', 'J-02-10-1', '', '', 'J-02-07-3', 'J-01-10-1', '', '', 'J-01-07-3'],
        ['J-04-11-3', '', '', 'J-04-06-1', 'J-03-11-3', '', '', 'J-03-06-1', 'J-02-11-3', '', '', 'J-02-06-1', 'J-01-11-3', '', '', 'J-01-06-1'],
        ['J-04-11-2', '', '', 'J-04-06-2', 'J-03-11-2', '', '', 'J-03-06-2', 'J-02-11-2', '', '', 'J-02-06-2', 'J-01-11-2', '', '', 'J-01-06-2'],
        ['J-04-11-1', '', '', 'J-04-06-3', 'J-03-11-1', '', '', 'J-03-06-3', 'J-02-11-1', '', '', 'J-02-06-3', 'J-01-11-1', '', '', 'J-01-06-3'],
        ['J-04-12-3', '', '', 'J-04-05-1', 'J-03-12-3', '', '', 'J-03-05-1', 'J-02-12-3', '', '', 'J-02-05-1', 'J-01-12-3', '', '', 'J-01-05-1'],
        ['J-04-12-2', '', '', 'J-04-05-2', 'J-03-12-2', '', '', 'J-03-05-2', 'J-02-12-2', '', '', 'J-02-05-2', 'J-01-12-2', '', '', 'J-01-05-2'],
        ['J-04-12-1', '', '', 'J-04-05-3', 'J-03-12-1', '', '', 'J-03-05-3', 'J-02-12-1', '', '', 'J-02-05-3', 'J-01-12-1', '', '', 'J-01-05-3'],
        ['J-04-13-3', '', '', 'J-04-04-1', 'J-03-13-3', '', '', 'J-03-04-1', 'J-02-13-3', '', '', 'J-02-04-1', 'J-01-13-3', '', '', 'J-01-04-1'],
        ['J-04-13-2', '', '', 'J-04-04-2', 'J-03-13-2', '', '', 'J-03-04-2', 'J-02-13-2', '', '', 'J-02-04-2', 'J-01-13-2', '', '', 'J-01-04-2'],
        ['J-04-13-1', '', '', 'J-04-04-3', 'J-03-13-1', '', '', 'J-03-04-3', 'J-02-13-1', '', '', 'J-02-04-3', 'J-01-13-1', '', '', 'J-01-04-3'],
        ['J-04-14-3', '', '', 'J-04-03-1', 'J-03-14-3', '', '', 'J-03-03-1', 'J-02-14-3', '', '', 'J-02-03-1', 'J-01-14-3', '', '', 'J-01-03-1'],
        ['J-04-14-2', '', '', 'J-04-03-2', 'J-03-14-2', '', '', 'J-03-03-2', 'J-02-14-2', '', '', 'J-02-03-2', 'J-01-14-2', '', '', 'J-01-03-2'],
        ['J-04-14-1', '', '', 'J-04-03-3', 'J-03-14-1', '', '', 'J-03-03-3', 'J-02-14-1', '', '', 'J-02-03-3', 'J-01-14-1', '', '', 'J-01-03-3'],
        ['J-04-15-3', '', '', 'J-04-02-1', 'J-03-15-3', '', '', 'J-03-02-1', 'J-02-15-3', '', '', 'J-02-02-1', 'J-01-15-3', '', '', 'J-01-02-1'],
        ['J-04-15-2', '', '', 'J-04-02-2', 'J-03-15-2', '', '', 'J-03-02-2', 'J-02-15-2', '', '', 'J-02-02-2', 'J-01-15-2', '', '', 'J-01-02-2'],
        ['J-04-15-1', '', '', 'J-04-02-3', 'J-03-15-1', '', '', 'J-03-02-3', 'J-02-15-1', '', '', 'J-02-02-3', 'J-01-15-1', '', '', 'J-01-02-3'],
        ['J-04-16-2', '', '', 'J-04-01-1', 'J-03-16-2', '', '', 'J-03-01-1', 'J-02-16-2', '', '', 'J-02-01-1', 'J-01-16-2', '', '', 'J-01-01-1'],
        ['J-04-16-1', '', '', 'J-04-01-2', 'J-03-16-1', '', '', 'J-03-01-2', 'J-02-16-1', '', '', 'J-02-01-2', 'J-01-16-1', '', '', 'J-01-01-2'],
        ['J-04-17-3', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
        ['J-04-17-2', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
        ['J-04-17-1', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
        ['', '', '', 'J-05-01-1', 'J-05-01-2', 'J-05-01-3', 'J-05-02-1', 'J-05-02-2', 'J-05-02-3', 'J-05-03-1', 'J-05-03-2', 'J-05-03-3', 'J-05-04-1', 'J-05-04-2', 'J-05-04-3', ''],
        ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
        ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''],
        ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']
    ]
};

export const allWarehouseHeights = [
    { shelf: 'D-01-01', width: 3, height: 4 },
    { shelf: 'D-01-02', width: 2, height: 4 },
    { shelf: 'D-01-03', width: 3, height: 4 },
    { shelf: 'D-01-04', width: 3, height: 4 },
    { shelf: 'D-01-05', width: 3, height: 4 },
    { shelf: 'D-01-06', width: 3, height: 4 },
    { shelf: 'D-01-07', width: 3, height: 4 },
    { shelf: 'D-01-08', width: 3, height: 4 },
    { shelf: 'D-01-09', width: 3, height: 4 },
    { shelf: 'D-01-10', width: 3, height: 4 },
    { shelf: 'D-01-11', width: 3, height: 4 },
    { shelf: 'D-01-12', width: 3, height: 4 },
    { shelf: 'D-01-13', width: 3, height: 4 },
    { shelf: 'D-01-14', width: 3, height: 4 },
    { shelf: 'D-01-15', width: 3, height: 4 },
    { shelf: 'D-01-16', width: 3, height: 4 },
    { shelf: 'D-01-17', width: 3, height: 4 },
    { shelf: 'D-01-18', width: 3, height: 4 },
    { shelf: 'D-01-19', width: 2, height: 4 },
    { shelf: 'D-02-01', width: 2, height: 4 },
    { shelf: 'D-02-02', width: 3, height: 4 },
    { shelf: 'D-02-03', width: 3, height: 4 },
    { shelf: 'D-02-04', width: 3, height: 4 },
    { shelf: 'D-02-05', width: 3, height: 4 },
    { shelf: 'D-02-06', width: 3, height: 4 },
    { shelf: 'D-02-07', width: 3, height: 4 },
    { shelf: 'D-02-08', width: 3, height: 4 },
    { shelf: 'D-02-09', width: 3, height: 4 },
    { shelf: 'D-02-10', width: 3, height: 4 },
    { shelf: 'D-02-11', width: 3, height: 4 },
    { shelf: 'D-02-12', width: 3, height: 4 },
    { shelf: 'D-02-13', width: 3, height: 4 },
    { shelf: 'D-02-14', width: 3, height: 4 },
    { shelf: 'D-02-15', width: 3, height: 4 },
    { shelf: 'D-02-16', width: 3, height: 4 },
    { shelf: 'D-02-17', width: 3, height: 4 },
    { shelf: 'D-02-18', width: 2, height: 4 },
    { shelf: 'D-03-01', width: 2, height: 4 },
    { shelf: 'D-03-02', width: 3, height: 4 },
    { shelf: 'D-03-03', width: 3, height: 4 },
    { shelf: 'D-03-04', width: 3, height: 4 },
    { shelf: 'D-03-05', width: 3, height: 4 },
    { shelf: 'D-03-06', width: 3, height: 4 },
    { shelf: 'D-03-07', width: 3, height: 4 },
    { shelf: 'D-03-08', width: 3, height: 4 },
    { shelf: 'D-03-09', width: 3, height: 4 },
    { shelf: 'D-03-10', width: 3, height: 4 },
    { shelf: 'D-03-11', width: 3, height: 4 },
    { shelf: 'D-03-12', width: 3, height: 4 },
    { shelf: 'D-03-13', width: 3, height: 4 },
    { shelf: 'D-03-14', width: 3, height: 4 },
    { shelf: 'D-03-15', width: 3, height: 4 },
    { shelf: 'D-03-16', width: 3, height: 4 },
    { shelf: 'D-03-17', width: 3, height: 4 },
    { shelf: 'D-03-18', width: 3, height: 4 },
    { shelf: 'D-04-01', width: 3, height: 3 },
    { shelf: 'D-04-02', width: 3, height: 3 },
    { shelf: 'D-04-03', width: 3, height: 3 },
    { shelf: 'D-04-04', width: 3, height: 3 },
    { shelf: 'D-04-05', width: 3, height: 3 },
    { shelf: 'D-04-06', width: 3, height: 3 },
    { shelf: 'D-04-07', width: 3, height: 3 },
    { shelf: 'D-04-08', width: 3, height: 3 },
    { shelf: 'D-04-09', width: 3, height: 3 },
    { shelf: 'D-04-10', width: 3, height: 3 },
    { shelf: 'D-04-11', width: 3, height: 3 },
    { shelf: 'D-04-12', width: 3, height: 3 },
    { shelf: 'D-04-13', width: 3, height: 3 },
    { shelf: 'D-04-14', width: 3, height: 3 },
    { shelf: 'D-04-15', width: 3, height: 3 },
    { shelf: 'D-04-16', width: 3, height: 3 },
    { shelf: 'D-04-17', width: 3, height: 3 },
    { shelf: 'D-04-18', width: 3, height: 3 },
    { shelf: 'D-05-01', width: 3, height: 2 },
    { shelf: 'D-05-02', width: 3, height: 2 },
    { shelf: 'D-05-03', width: 3, height: 2 },
    { shelf: 'D-05-04', width: 3, height: 2 },
    { shelf: 'D-05-05', width: 3, height: 2 },
    { shelf: 'J-01-01', width: 2, height: 2 },
    { shelf: 'J-01-02', width: 3, height: 2 },
    { shelf: 'J-01-03', width: 3, height: 2 },
    { shelf: 'J-01-04', width: 3, height: 2 },
    { shelf: 'J-01-05', width: 3, height: 2 },
    { shelf: 'J-01-06', width: 3, height: 2 },
    { shelf: 'J-01-07', width: 3, height: 2 },
    { shelf: 'J-01-08', width: 3, height: 2 },
    { shelf: 'J-01-09', width: 3, height: 2 },
    { shelf: 'J-01-10', width: 3, height: 2 },
    { shelf: 'J-01-11', width: 3, height: 2 },
    { shelf: 'J-01-12', width: 3, height: 2 },
    { shelf: 'J-01-13', width: 3, height: 2 },
    { shelf: 'J-01-14', width: 3, height: 2 },
    { shelf: 'J-01-15', width: 3, height: 2 },
    { shelf: 'J-01-16', width: 2, height: 2 },
    { shelf: 'J-02-01', width: 2, height: 2 },
    { shelf: 'J-02-02', width: 3, height: 2 },
    { shelf: 'J-02-03', width: 3, height: 2 },
    { shelf: 'J-02-04', width: 3, height: 2 },
    { shelf: 'J-02-05', width: 3, height: 2 },
    { shelf: 'J-02-06', width: 3, height: 2 },
    { shelf: 'J-02-07', width: 3, height: 2 },
    { shelf: 'J-02-08', width: 3, height: 2 },
    { shelf: 'J-02-09', width: 3, height: 2 },
    { shelf: 'J-02-10', width: 3, height: 2 },
    { shelf: 'J-02-11', width: 3, height: 2 },
    { shelf: 'J-02-12', width: 3, height: 2 },
    { shelf: 'J-02-13', width: 3, height: 2 },
    { shelf: 'J-02-14', width: 3, height: 2 },
    { shelf: 'J-02-15', width: 3, height: 2 },
    { shelf: 'J-02-16', width: 2, height: 2 },
    { shelf: 'J-03-01', width: 2, height: 2 },
    { shelf: 'J-03-02', width: 3, height: 2 },
    { shelf: 'J-03-03', width: 3, height: 2 },
    { shelf: 'J-03-04', width: 3, height: 2 },
    { shelf: 'J-03-05', width: 3, height: 2 },
    { shelf: 'J-03-06', width: 3, height: 2 },
    { shelf: 'J-03-07', width: 3, height: 2 },
    { shelf: 'J-03-08', width: 3, height: 2 },
    { shelf: 'J-03-09', width: 3, height: 2 },
    { shelf: 'J-03-10', width: 3, height: 2 },
    { shelf: 'J-03-11', width: 3, height: 2 },
    { shelf: 'J-03-12', width: 3, height: 2 },
    { shelf: 'J-03-13', width: 3, height: 2 },
    { shelf: 'J-03-14', width: 3, height: 2 },
    { shelf: 'J-03-15', width: 3, height: 2 },
    { shelf: 'J-03-16', width: 2, height: 2 },
    { shelf: 'J-04-01', width: 2, height: 2 },
    { shelf: 'J-04-02', width: 3, height: 2 },
    { shelf: 'J-04-03', width: 3, height: 2 },
    { shelf: 'J-04-04', width: 3, height: 2 },
    { shelf: 'J-04-05', width: 3, height: 2 },
    { shelf: 'J-04-06', width: 3, height: 2 },
    { shelf: 'J-04-07', width: 3, height: 2 },
    { shelf: 'J-04-08', width: 3, height: 2 },
    { shelf: 'J-04-09', width: 3, height: 2 },
    { shelf: 'J-04-10', width: 3, height: 2 },
    { shelf: 'J-04-11', width: 3, height: 2 },
    { shelf: 'J-04-12', width: 3, height: 2 },
    { shelf: 'J-04-13', width: 3, height: 2 },
    { shelf: 'J-04-14', width: 3, height: 2 },
    { shelf: 'J-04-15', width: 3, height: 2 },
    { shelf: 'J-04-16', width: 2, height: 2 },
    { shelf: 'J-04-17', width: 3, height: 2 },
    { shelf: 'J-05-01', width: 3, height: 2 },
    { shelf: 'J-05-02', width: 3, height: 2 },
    { shelf: 'J-05-03', width: 3, height: 3 },
    { shelf: 'J-05-04', width: 3, height: 3 }
]